// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2QJfK","productName":"Table_productName__3S3rb"};